import {Component, Prop, Vue, Emit} from 'vue-property-decorator';
import Service from '../../../../common/src/assets/service/service';
import Common from '../../../../common/src/assets/js/common';
import commonFilter from '../../../../common/src/assets/filters/common.filter';
import TimeCommon from '../../../../common/src/assets/js/timeCommon';
import LoginFooter from "../../components/login-footer/login-footer.vue";

@Component({
    components: {
        LoginFooter,
    },
    filters: {
        ...commonFilter,
    }
})
export default class Payment extends Vue {
    private $route: any;
    private $router: any;
    private $layer: any;
    private userID: string = '';
    private time: string = '10:00';
    private timer: any = null;
    private statusTimer: any = null;
    private isLoadErr: Boolean = false;
    private loading: string = ''; // loading , havedata , nodata
    private statusLoad: string = 'loading';  // loading, eroor, success
    private type: string = 'alipay';  // alipay, weipay
    private money: number = 0;
    private apiType: string = ''; // 接口类型

    // 支付参数
    private payParams: any = {
        userID: '',
        money: 0,
        type: '',
    };
    // 账单支付参数
    private billPayParams: any = {
        userID: '',
        money: 0,
        payType: '',
        monthBillCode: ''
    };
    // 二维码数据
    private payData: any = {
        code: '',
        qrcode: '',
        countTime: 0,
    };

    private created() {
        this.userID = Common.getUserID();
        let query = this.$route.query;
        if (query.apiType && query.money && query.type) {
            debugger
            this.apiType = query.apiType;
            switch (this.apiType) {
                case 'recharge':
                  this.payParams.money = this.money = +query['money'];
                  this.payParams.type = this.type // = query['type']; // 只有支付宝就不用接收了
                  break;
                case 'bill':
                  this.billPayParams.money = this.money = +query['money'];
                  this.billPayParams.payType = this.type = query['type'];
                  this.billPayParams.monthBillCode = query['monthBillCode'];
                  break;
              }
              this.selectGetData();
        } else {
            this.$layer.msg('参数信息有误！', {type: 'error'})
            this.timeoutGoHome(2000);
        }
    }

    /**选择支付api方法 */
    private selectGetData() {
        switch (this.apiType) {
            case 'recharge':
                this.getPayData();
                break;
            case 'bill':
                // this.getBillPayData();
                break;
        }
    }

    /**获取支付数据（账户充值） */
    private getPayData() {
        this.payParams.userID = this.userID;
        this.statusLoad = 'loading';
        this.payData.qrcode = '';
        // this.payData.code = '';
        Service.request('/user/createRechargeBill',this.payParams, 'token').then((data: any) => {
            this.statusLoad = 'havedata';
            this.payData.code = data['data']['billCode'];
            this.payData.countTime = data['data']['timeoutExpress'];
            let qrBase64 = data['data']['qrcode'];
            this.payData.qrcode = this.base64ToImage(qrBase64);
            this.initCountDown();
            this.isLoadErr = false;

            // 每5秒查询支付状态
            clearInterval(this.statusTimer);
            this.statusTimer = null;
            this.getPayStatus();
        }).catch(error => {
            this.statusLoad = 'error';
            this.isLoadErr = true;
            this.$layer.msg(error.errorMsg, {type: 'error'})
        });

    }

    /**base64转图片 */
    private base64ToImage(str: string) {
        return 'data:image/png;base64,' + str;
    }

    /**初始化倒计时 */
    private initCountDown() {
        let countTime = this.payData.countTime * 60;

        this.timer = setInterval(() => {
        countTime -= 1;
        this.time = TimeCommon.addZero(Math.floor(countTime / 60)) + ':' + TimeCommon.addZero(Math.floor(countTime % 60));
        if (countTime <= 0) {
            clearInterval(this.timer);
            this.timer = null;
            this.statusLoad = 'error';
        }
        }, 1000);
    }
    /**获取支付状态(账户充值) */
    private getPayStatus() {
        this.statusTimer = setInterval(() => {
        let params = {
            userID: this.userID,
            billCode: this.payData.code
        };
        Service.request('',params).then((data: any) => {
            let order = data['data']['data'][0];
            if (+order['status'] === 1) {
                this.statusLoad = 'success';
                clearInterval(this.timer);
                clearInterval(this.statusTimer);
                this.timer = null;
                this.statusTimer = null;
                this.$layer.msg('支付成功，3秒后跳转回首页', {type: 'success', time: 3000})
                this.timeoutGoHome();
            }
        }).catch(error => {
            clearInterval(this.statusTimer);
            this.$layer.msg(error.errorMsg, {type: 'error'})
        });
        }, 2000);
    }

    /**获取账单支付数据（账单支付） */
    private getBillPayData() {
        this.billPayParams.userID = this.userID;
        this.statusLoad = 'loading';
        this.payData.qrcode = '';
        Service.request('',this.billPayParams).then((data: any) => {
            this.statusLoad = 'havedata';
            this.payData.code = data['data']['billCode'];
            this.payData.countTime = data['data']['timeoutExpress'];
            let qrBase64 = data['data']['qrcode'];
            this.payData.qrcode = this.base64ToImage(qrBase64);
            this.initCountDown();
            this.isLoadErr = false;

            // 每5秒查询支付状态
            clearInterval(this.statusTimer);
            this.statusTimer = null;
            this.getPayStatus();
        }, error => {
            this.statusLoad = 'error';
            this.isLoadErr = true;
            this.$layer.msg(error.errorMsg, {type: 'error'})
        });
    }
    /**3s后返回首页 */
    private timeoutGoHome(time: number = 3000) {
        setTimeout(() => {
            window.location.href = './';
        }, time);
    }
}